import axios from "axios";
import { getEnhancedAuthHeaders } from "./auth";
const backendUrl = process.env.REACT_APP_BACKEND_URL_FOR_FRONTEND;

// ----------- POST -----------
/**
 * Verifies a TOTP (Time-based One-Time Password) code during two-factor authentication.
 *
 * This function sends the user ID and TOTP token to the backend for verification.
 * If successful, returns the full authentication data including JWT token and user information.
 *
 * @async
 * @param {number|string} userId - The user's ID from the partial authentication step
 * @param {string} token - The 6-digit TOTP code entered by the user
 * @returns {Promise<Object>} Authentication data containing:
 *   - token {string} - JWT authentication token
 *   - userId {number} - User's ID
 *   - roles {string} - User's role(s)
 *   - lastname {string} - User's last name
 *   - firstname {string} - User's first name
 *   - company_id {number} - User's company ID
 *   - companyname {string} - User's company name
 *   - language {string} - User's preferred language
 *   - timezone_offset {number} - User's timezone offset
 *
 * @throws {Error} Throws an error if the TOTP verification fails or if there's a network issue
 **/
export const verifyTotp = async (userId, token) => {
  try {
    const response = await axios.post(`${backendUrl}/login/verify-totp`, {
      userId,
      token,
    });

    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

/**
 * SETUP 2FA
 *
 *
 * **/

/**
 * Initiates 2FA setup for a user by generating a new TOTP secret and QR code
 * 
 * @async
 * @returns {Promise<Object>} Setup data containing QR code URL and secret key
 * @throws {Error} Throws an error if the setup fails or if there's a network issue
 */
export const setup2fa = async () => {
  try {
    const response = await axios.post(
      `${backendUrl}/login/setup-2fa`,
      {}, // Empty body
      { headers: getEnhancedAuthHeaders() }
    );
    
    return response.data;
  } catch (error) {
    console.error("2FA setup error:", error);
    throw error;
  }
};